import Title from 'antd/es/typography/Title';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Button, Tooltip } from 'ui';
import { StyledSpecialistInfo } from './style';
import { useUserState } from 'contexts/UserContext';
import useJwt from 'utils/useJwt';
import UnauthenticatedModal from 'components/Modals/UnauthenticatedModal';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserGroups } from 'constants/userGroups';
import useTooltip from 'utils/useTooltip';
import { useSystemSettingState } from '../../../../../../../contexts/SystemSettingContext';
import UnverifiedEmail from '../../../../../../../components/Modals/UnverifiedEmail';

interface SpecialistInfoProps {
  isThereSubmissionPeriod: boolean;
  isMunicipalLoading: boolean;
  hasSubmissionPeriod?: boolean;
  budget?: any;
}

export const SpecialistInfo = ({
  hasSubmissionPeriod,
  isThereSubmissionPeriod,
  isMunicipalLoading,
  budget,
}: SpecialistInfoProps) => {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);

  const intl = useIntl();
  let [searchParams] = useSearchParams();
  const { isTokenActive } = useJwt();
  const user = useUserState();
  const activeRole = user.roles.find((e) => e.id === user.selectedRole);

  const navigate = useNavigate();
  const { getRestrictionTooltip } = useTooltip('');
  const {
    device: { isMobile },
  } = useSystemSettingState();

  const atvkId = searchParams.get('atvk_id');
  const { contact_person_name: name, contact_person_email: email, contact_person_phone: phone } = budget || {};

  const closeModal = () => {
    setShowAuthModal(false);
  };

  const renderSubmitButton = () => {
    let restrictionTooltip = getRestrictionTooltip('submit-project', {
      user,
      project: { atvk_id: budget?.atvk_id },
      section: 'project-list',
    });

    if (isMobile && restrictionTooltip === 'notification.to_submit_verify_email') {
      restrictionTooltip = '';
    }

    const isLoggedIn = isTokenActive();
    const isEnabled = !isLoggedIn || !restrictionTooltip;

    if (!hasSubmissionPeriod) {
      return null;
    }

    return (
      <Tooltip
        className="submit-button mt-5"
        hack
        title={restrictionTooltip && intl.formatMessage({ id: restrictionTooltip })}
        placement="topRight"
      >
        <Button
          loading={isMunicipalLoading}
          disabled={!isEnabled || !isThereSubmissionPeriod}
          type="primary"
          label={intl.formatMessage({ id: 'participation_budget.submit_projects' })}
          onClick={() => {
            if (!isLoggedIn) {
              setShowAuthModal(true);
            } else if (!activeRole?.emailVerified) {
              setShowEmailModal(true);
            } else if (!restrictionTooltip) {
              navigate(`/main?participation-budget=open&submit-project=open&atvk_id=${atvkId}`);
            }
          }}
        />
      </Tooltip>
    );
  };

  return (
    <StyledSpecialistInfo>
      {hasSubmissionPeriod && (
        <div className="info">
          <div>
            <Title level={5} className="title">
              {intl.formatMessage({ id: 'participation_budget.specialist_info' })}
            </Title>
            <Title level={4} className="name">
              {name}
            </Title>
            <a href="">{email}</a>
            <p>{`+371 ${phone}`}</p>
          </div>
          <div className="documents">
            <Title level={5} className="title">
              {intl.formatMessage({ id: 'participation_budget.regulations_other_documents' })}
            </Title>
            <ol>
              {budget?.attachments?.map((e: any) => (
                <li>
                  <a target="_blank" href={e.url}>
                    {e.name}
                  </a>
                </li>
              ))}
            </ol>
          </div>
        </div>
      )}
      {renderSubmitButton()}
      <UnauthenticatedModal showModal={showAuthModal} setShowModal={closeModal} />
      <UnverifiedEmail showModal={showEmailModal} setShowModal={setShowEmailModal} />
    </StyledSpecialistInfo>
  );
};
